/* eslint-disable no-nested-ternary */
/* eslint-disable no-alert */
import React from "react";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";

import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@material-ui/core";
import DocTableHead from "./DocTableHead";
import { dateParser } from "../../../../../../helpers/dateParser";

export default function Table02({ data, classes, setActiveFolder }) {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen((o) => !o);
  };

  const {
    national_id,
    national_id_doc,
    national_id_doc_created_at,
    registery_no,
  } = data;

  const format = national_id_doc?.split(".")?.at(-1) || null;

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <Table>
          <DocTableHead
            classes={classes}
            handleOpen={handleOpen}
            name="سند استعلام شناسه ملی"
            index={2}
          />
          <TableBody
            style={{
              visibility: open ? "visible" : "collapse",
            }}
          >
            <TableRow>
              <TableCell className={classes.cells}>
                <Typography variant="h5" className={classes.tValue}>
                  {format}
                </Typography>
              </TableCell>
              <TableCell className={classes.cells}>
                <Typography variant="h5" className={classes.tKey}>
                  شناسه ثبت:{" "}
                  <span className={classes.tValue}>
                    {registery_no || "____"}
                  </span>{" "}
                  <span style={{ margin: 10 }}></span> شناسه ملی:{" "}
                  <span className={classes.tValue}>
                    {national_id || "____"}
                  </span>
                </Typography>
              </TableCell>
              <TableCell className={classes.cells} align="center">
                <Typography variant="h5" className={classes.t2}>
                  {national_id_doc_created_at
                    ? dateParser(national_id_doc_created_at)
                    : "____"}
                </Typography>
              </TableCell>
              <TableCell
                className={classes.cells}
                onClick={() => setActiveFolder(national_id_doc)}
              >
                {!!national_id_doc ? (
                  <RemoveRedEyeOutlinedIcon className={classes.iconEye} />
                ) : (
                  <VisibilityOffOutlinedIcon className={classes.iconEye} />
                )}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Grid>
    </Grid>
  );
}
